import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CardCarousel from '@homeaway/react-card-carousel';
import { AspectRatioCard } from '@homeaway/react-aspect-ratio-card';
import IsBrowser from '../IsBrowser';

// IMPORTANT - This logic must be kept in sync with src/universal/components/Carousel/Carousel.less

import './Carousel.less';

class Carousel extends Component {
  static propTypes = {
    title: PropTypes.string,
    subheading: PropTypes.string,
    onPreviousClick: PropTypes.func,
    onNextClick: PropTypes.func,
    isTouchDevice: PropTypes.bool,
    cardAspectRatio: PropTypes.string,
    breakpoints: PropTypes.shape(),
    ssrEnabled: PropTypes.bool
  }

  static defaultProps = {
    title: '',
    subheading: '',
    cardAspectRatio: '4x3',
    breakpoints: {
      '1600': 5,
      '1200': 4,
      '992': 4,
      '768': 3,
      '480': 3,
      '0': 2
    },
    onPreviousClick: () => {},
    onNextClick: () => {},
    ssrEnabled: false
  }

  constructor(props) {
    super(props);

    this.state = {
      index: 0
    };
  }

  handlePrevNext = cb => (evt, newIndex) => {
    this.setState({
      index: newIndex
    });
    cb();
  }

  getControlOffset = (aspectRatio) => {
    return (width, controlHeight) => {
      return AspectRatioCard.getControlOffset(width, controlHeight, aspectRatio);
    };
  }

  render() {
    const {
      children,
      title,
      subheading,
      isTouchDevice,
      onPreviousClick,
      onNextClick,
      cardAspectRatio,
      breakpoints,
      ssrEnabled,
      ...otherProps
    } = this.props;

    let content = (
      <CardCarousel
        breakpoints={breakpoints}
        cardIndex={this.state.index}
        onPreviousClick={this.handlePrevNext(onPreviousClick)}
        onNextClick={this.handlePrevNext(onNextClick)}
        title={title}
        subheading={subheading}
        scrolling={isTouchDevice}
        paging
        getControlOffset={this.getControlOffset(cardAspectRatio)}
        className="carousel"
        {...otherProps}
      >
        {children}
      </CardCarousel>
    );

    if (ssrEnabled) {
      content = <div className="carousel-ssr">{content}</div>;
    } else {
      const placeholder = <div className="carousel-placeholder" />;
      content = <IsBrowser withTransition placeHolder={placeholder}>{content}</IsBrowser>;
    }

    return content;
  }
}

export default Carousel;
